import { TimezoneResponseDTO } from '@/core/api/dtos/response/misc/timezone'
import { Timezone } from '@/core/api/entities/misc/timezone'

export class TimezoneMapper {
	static toEntity(dto: TimezoneResponseDTO): Timezone {
		return Timezone.create(dto)
	}

	static toEntities(dtos: TimezoneResponseDTO[]): Timezone[] {
		return dtos.map(this.toEntity)
	}
}
